"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IncomeFormFields = exports.TOTAL_INCOME_NOT_SHOWN = exports.NO_INCOME = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _theme = require("../../theme");

var _basis = require("basis");

var _ = require("./..");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof3(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof3(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof3(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var CheckboxGroupWrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  // hides the error messages on the CheckboxGroup components\n  & > div:nth-of-type(2) {\n    & > div:nth-of-type(3) {\n      display: none;\n    }\n  }\n"])));

var s = {
  CheckboxGroupWrapper: CheckboxGroupWrapper
};

var groupHasSelections = function groupHasSelections(values) {
  return Object.keys(values).reduce(function (flag, key) {
    if (!flag) {
      return values[key] ? true : flag;
    }

    return flag;
  }, false);
};

var formHasSelections = function formHasSelections(values) {
  return Object.keys(values).reduce(function (flag, key) {
    if (!flag) {
      if (typeof values[key] === 'boolean') {
        return values[key] ? true : flag;
      }

      if ((0, _typeof2.default)(values[key]) === 'object') {
        return Object.keys(values[key]).reduce(function (oFlag, oKey) {
          if (!oFlag) {
            return values[key][oKey] ? true : oFlag;
          }

          return oFlag;
        }, false);
      }
    }

    return flag;
  }, false);
};

var NO_INCOME = 'noIncome';
exports.NO_INCOME = NO_INCOME;
var TOTAL_INCOME_NOT_SHOWN = 'totalIncomeNotShown';
exports.TOTAL_INCOME_NOT_SHOWN = TOTAL_INCOME_NOT_SHOWN;

var IncomeFormFields = function IncomeFormFields(props) {
  var optionGroups = props.optionGroups,
      formData = props.formData,
      initialValues = props.initialValues,
      errorMessage = props.errorMessage,
      totalIncomeNotShownErrorMessage = props.totalIncomeNotShownErrorMessage,
      disabled = props.disabled,
      enableNoneAreMyIncome = props.enableNoneAreMyIncome,
      enableTotalIncomeNotShown = props.enableTotalIncomeNotShown;
  var theme = (0, _theme.useTheme)();
  var resetValues = (0, _react.useMemo)(function () {
    var _ref;

    var noIncome = initialValues[NO_INCOME],
        totalIncomeNotShown = initialValues[TOTAL_INCOME_NOT_SHOWN],
        rest = (0, _objectWithoutProperties2.default)(initialValues, [NO_INCOME, TOTAL_INCOME_NOT_SHOWN].map(_toPropertyKey));
    return _ref = {
      groups: _objectSpread({}, rest)
    }, (0, _defineProperty2.default)(_ref, NO_INCOME, noIncome), (0, _defineProperty2.default)(_ref, TOTAL_INCOME_NOT_SHOWN, totalIncomeNotShown), _ref;
  }, [initialValues]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isDirty = _useState2[0],
      setIsDirty = _useState2[1];

  var validate = (0, _react.useCallback)(function (value) {
    if (formHasSelections(formData.state.values)) {
      return null;
    }

    if (typeof value === 'boolean') {
      if (!value) {
        return errorMessage;
      }
    } else {
      if (!groupHasSelections(value)) {
        return errorMessage;
      }
    }

    return null;
  }, [errorMessage, formData.state.values]);
  var totalIncomeNotShownValidate = (0, _react.useCallback)(function (value) {
    if (formHasSelections(formData.state.values)) {
      return null;
    }

    if (typeof value === 'boolean') {
      if (!value) {
        return totalIncomeNotShownErrorMessage;
      }
    } else {
      if (!groupHasSelections(value)) {
        return totalIncomeNotShownErrorMessage;
      }
    }

    return null;
  }, [formData.state.values, totalIncomeNotShownErrorMessage]);
  (0, _react.useEffect)(function () {
    var _formData$state$error;

    if (!isDirty && (_formData$state$error = formData.state.errors) !== null && _formData$state$error !== void 0 && _formData$state$error[NO_INCOME]) {
      setIsDirty(true);
    }
  }, [isDirty, initialValues, formData.state.errors]);

  var handleGroupChange = function handleGroupChange(id) {
    return function (_ref2) {
      var value = _ref2.value;

      if (groupHasSelections(value)) {
        var _objectSpread2;

        // uncheck noIncome checkbox, remove any errors
        var _formData$state$value = formData.state.values,
            noIncome = _formData$state$value[NO_INCOME],
            totalIncomeNotShown = _formData$state$value[TOTAL_INCOME_NOT_SHOWN],
            rest = (0, _objectWithoutProperties2.default)(_formData$state$value, [NO_INCOME, TOTAL_INCOME_NOT_SHOWN].map(_toPropertyKey));
        formData.resetForm({
          values: _objectSpread(_objectSpread({}, rest), {}, (_objectSpread2 = {}, (0, _defineProperty2.default)(_objectSpread2, id, value), (0, _defineProperty2.default)(_objectSpread2, NO_INCOME, false), (0, _defineProperty2.default)(_objectSpread2, TOTAL_INCOME_NOT_SHOWN, totalIncomeNotShown), _objectSpread2)),
          errors: {}
        });
      } else {
        if (isDirty && !formHasSelections(_objectSpread(_objectSpread({}, formData.state.values), {}, (0, _defineProperty2.default)({}, id, value)))) {
          // set error on the noIncome checkbox
          formData.resetForm({
            errors: (0, _defineProperty2.default)({}, NO_INCOME, [errorMessage])
          });
        }
      }
    };
  };

  var handleNoIncomeChange = function handleNoIncomeChange(_ref3) {
    var isChecked = _ref3.isChecked;

    if (isChecked) {
      var _objectSpread4;

      // uncheck any checked income checkboxes, remove any errors
      formData.resetForm({
        values: _objectSpread(_objectSpread({}, resetValues.groups), {}, (_objectSpread4 = {}, (0, _defineProperty2.default)(_objectSpread4, NO_INCOME, true), (0, _defineProperty2.default)(_objectSpread4, TOTAL_INCOME_NOT_SHOWN, false), _objectSpread4)),
        errors: {}
      });
    }
  };

  var handletotalIncomeNotShown = function handletotalIncomeNotShown(_ref4) {
    var isChecked = _ref4.isChecked;
    var _formData$state$value2 = formData.state.values,
        noIncome = _formData$state$value2[NO_INCOME],
        totalIncomeNotShown = _formData$state$value2[TOTAL_INCOME_NOT_SHOWN],
        rest = (0, _objectWithoutProperties2.default)(_formData$state$value2, [NO_INCOME, TOTAL_INCOME_NOT_SHOWN].map(_toPropertyKey));

    if (isChecked) {
      var _objectSpread5;

      formData.resetForm({
        values: _objectSpread(_objectSpread({}, rest), {}, (_objectSpread5 = {}, (0, _defineProperty2.default)(_objectSpread5, NO_INCOME, false), (0, _defineProperty2.default)(_objectSpread5, TOTAL_INCOME_NOT_SHOWN, !totalIncomeNotShown), _objectSpread5)),
        errors: {}
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, optionGroups.map(function (group) {
    return /*#__PURE__*/_react.default.createElement(s.CheckboxGroupWrapper, {
      key: group.id,
      "data-testid": "institution-checkbox-group"
    }, group.label, /*#__PURE__*/_react.default.createElement(_basis.CheckboxGroup, {
      name: group.id,
      label: "",
      options: group.options,
      validate: validate,
      onChange: handleGroupChange(group.id),
      disabled: disabled,
      color: theme.inputColor
    }));
  }), enableNoneAreMyIncome && /*#__PURE__*/_react.default.createElement(_basis.Checkbox, {
    name: NO_INCOME,
    label: "",
    validate: validate,
    onChange: handleNoIncomeChange,
    testId: "no-income-checkbox",
    disabled: disabled,
    color: theme.inputColor
  }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
    path: "income.optionNoIncome"
  })), enableTotalIncomeNotShown && /*#__PURE__*/_react.default.createElement(_basis.Container, null, /*#__PURE__*/_react.default.createElement(_basis.Text, {
    textStyle: theme.headingSize,
    color: theme.headingColor
  }, "Can\u2019t see all your income?"), /*#__PURE__*/_react.default.createElement(_basis.Checkbox, {
    name: TOTAL_INCOME_NOT_SHOWN,
    validate: totalIncomeNotShownValidate,
    onChange: handletotalIncomeNotShown,
    testId: "not-show-total-income-checkbox",
    disabled: disabled,
    color: theme.inputColor
  }, /*#__PURE__*/_react.default.createElement(_.TextContent, {
    path: "income.totalIncomeNotShown"
  }))));
};

exports.IncomeFormFields = IncomeFormFields;